<div class="welcome">
    <header class="welcome__header" v-if="orgData.adminFirstName">
        Hello {{ orgData.adminFirstName }}
    </header>
    <div class="welcome__content">
        <div class="welcome__content-header">
            <img class="welcome__header-img" src="../../../../resources/images/play.png" alt="">
            <div class="welcome__heading">Welcome to the Monjin Platform</div>
        </div>
        <div class="welcome__content-heading">We thank you for trying out Monjin.
            We are glad that you have given us the opportunity to showcase a one-stop shop for your hiring needs.
            To get the best out of your trial experience, we implore you to use the Platform to:
        </div>
        <ul class="welcome__content-points">
            <li>Post a Job<a href="https://help.monjin.com/post-a-job-looking-to-hire-create-jd/" target="_blank"><mom-icon svgIcon="launch" width="18"></mom-icon></a></li>
            <li>Search from our vetted database for your right candidate<a href="https://help.monjin.com/search-2/" target="_blank"><mom-icon svgIcon="launch" width="18"></mom-icon></a></li>
            <li>Configure your own questionnaires and invite candidates to showcase themselves via Monjin Spotlight<a href="https://help.monjin.com/manage-questionnaire/" target="_blank"><mom-icon svgIcon="launch" width="18"></mom-icon></a></li>
            <li>Schedule multi-party interviews of potential applicants with your interviewers<a href="https://help.monjin.com/schedules-2/" target="_blank"><mom-icon svgIcon="launch" width="18"></mom-icon></a></li>
        </ul>
        <div class="welcome__subheading">We are always here to help and you can reach out to us at
            <a href="mailto:info@monjin.com">info@monjin.com</a>
            <br/>for queries and feedback. You can also visit <a href="https://help.monjin.com/" target="_blank">help.monjin.com</a> for a complete user guide.
        </div>
        <div class="welcome__proceed">
            <mom-button variant="raised" @click="onContinue">Let's go</mom-button>
        </div>
    </div>
</div>